import {defineNuxtPlugin, useAsyncData, useLogger, useUniversalFetch} from '#imports';
import {useDataLayer, type DataLayer} from '../composables/useDataLayer';

export default defineNuxtPlugin({
    name: 'tracking-datalayer',
    parallel: true,
    async setup(nuxtApp) {
        if (!nuxtApp.$config.public.tracking.enabled) {
            return;
        }
        const logger = useLogger();
        const dataLayer = useDataLayer();

        const {data, error} = await useAsyncData('tracking-datalayer', () => useUniversalFetch<DataLayer>('/api/datalayer'));
        if (error.value) {
            logger.error('Error while fetching data layer', error.value);
            return;
        }

        if (!data.value) {
            logger.error('No data layer found');
            return;
        }

        dataLayer.value = data.value;
    },
});
